import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../redux/network/https";
import { endPoints } from "../../redux/network/constant";

const fetchPreferences = async () => {
  const { data } = await axiosInstance.get(endPoints.NotificationPreferences);
  return data;
};

const fetchNotifications = async ({ page = 1, pageSize = 20 } = {}) => {
  const { data } = await axiosInstance.get(endPoints.Notifications, {
    params: { page, page_size: pageSize },
  });
  return data;
};

const putPreferences = async (preferences) => {
  const { data } = await axiosInstance.put(endPoints.UpdateNotificationPreferences, preferences);
  return data;
};

const cancelNotification = async (notificationId) => {
  const { data } = await axiosInstance.post(
    endPoints.CancelNotification(notificationId),
  );
  return data;
};

export const useNotificationPreferences = (enabled = true) => {
  return useQuery({
    queryKey: ["notifications", "preferences"],
    queryFn: fetchPreferences,
    enabled,
  });
};

export const useUpdateNotificationPreferences = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putPreferences,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications", "preferences"] });
    },
  });
};

export const useCancelNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications", "list"] });
    },
  });
};

export const useNotifications = ({ page = 1, pageSize = 20 } = {}, enabled = true) => {
  return useQuery({
    queryKey: ["notifications", "list", page, pageSize],
    queryFn: () => fetchNotifications({ page, pageSize }),
    enabled,
    staleTime: 30 * 1000,
  });
};
